import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function PageHeader({ overline, title, subtitle, breadcrumbs }) {
  return (
    <section className="relative overflow-hidden bg-[#0F172A] text-white pt-24 pb-16 md:pt-32 md:pb-24">
      <div className="pz-blob bg-[#2563EB] w-[360px] h-[360px] -top-32 -left-32 opacity-40" />
      <div className="pz-blob bg-[#F59E0B] w-[300px] h-[300px] bottom-[-160px] right-[-80px] opacity-25" />
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.5) 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
      />
      <div className="relative pz-container">
        {breadcrumbs && (
          <nav data-testid="page-breadcrumbs" className="text-xs uppercase tracking-[0.22em] text-white/60 mb-5 flex flex-wrap items-center gap-2">
            {breadcrumbs.map((b, i) => (
              <span key={i} className="flex items-center gap-2">
                {b.to ? (
                  <Link to={b.to} className="hover:text-[#F59E0B]">{b.label}</Link>
                ) : (
                  <span className="text-white/90">{b.label}</span>
                )}
                {i < breadcrumbs.length - 1 && <span className="text-white/30">/</span>}
              </span>
            ))}
          </nav>
        )}
        {overline && <span className="pz-overline" style={{ color: "#F59E0B" }}>{overline}</span>}
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-tight"
        >
          {title}
        </motion.h1>
        <div className="pz-gold-line mt-6" />
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="mt-6 text-white/75 text-lg max-w-2xl"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
